import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface TeamSelectorProps {
    teamId: string;
    onTeamIdChange: (teamId: string) => void;
}

export function TeamSelector({teamId, onTeamIdChange}: TeamSelectorProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="space-y-2">
            <Label htmlFor="userTeamId">{t('admin.users.createUserDialog.teamId')} *</Label>
            <Input
                id="userTeamId"
                type="text"
                value={teamId}
                onChange={(e) => onTeamIdChange(e.target.value)}
                placeholder={t('admin.users.createUserDialog.teamIdPlaceholder')}
            />
        </div>
    );
}